import { Injectable } from '@angular/core';
import { CloudfunctriggersService } from './cloudfunctriggers.service';

@Injectable({
  providedIn: 'root'
})
export class KeyringService {

  constructor(
    private cloudFunctionTriggers:CloudfunctriggersService
  ) { }

  claimkeyring(keyringId:string){
    return this.cloudFunctionTriggers.claimKeyring(keyringId)
  }
}
